export const getUrlPath = (to) => {
  return to?.replace(process.env.GATSBY_SITE_URL, '');
};
